import React from 'react'
import { StyledIconWMO } from './StyledIconWMO'

const CpPlusSymbolGreen = ({
  width = '40px',
  height = '38px',
}) => (
  <StyledIconWMO
    a11yTitle="usericon"
    width={width}
    height={height}
    viewBox="0 0 40 38"
    fill="none"
  >
    <g clipPath="url(#clip0_6488_548338)">
      <path d="M26.8485 10.4947L28.8581 0.0517578H24.4565L22.5437 9.99122C21.7394 14.3872 24.3218 18.2011 29.1511 18.2011H39.1266L40.0002 13.7459H29.4738C27.6783 13.7459 26.5029 12.2904 26.8482 10.4947H26.8485Z" fill="#59C369" />
      <path d="M13.152 27.4955L11.1424 37.9384H15.544L17.4568 27.9989C18.2611 23.6029 15.6787 19.7891 10.8493 19.7891H0.8736L0 24.2443H10.5264C12.3219 24.2443 13.4973 25.6997 13.152 27.4955Z" fill="#59C369" />
      <path d="M38.8651 19.6558L28.7947 19.6486C23.627 19.6446 20.0838 15.4536 21.0784 10.2854L23.0478 0.0517578H18.5424L16.4384 10.9854C16.3846 11.2651 16.3472 11.543 16.3259 11.8182C16.2622 12.6438 16.3438 13.4435 16.5635 14.1843C16.5878 14.2664 16.5651 14.351 16.5163 14.4195C16.435 14.5334 16.2816 14.6024 16.1547 14.5398C15.3062 14.1219 14.3336 13.8987 13.2939 13.8987H1.96458L1.10938 18.3427L11.1798 18.3499C16.3475 18.3539 19.8907 22.5448 18.896 27.7131L16.9267 37.9464H21.432L23.536 27.0128C23.5899 26.7331 23.6272 26.4552 23.6486 26.18C23.7123 25.3544 23.6307 24.5547 23.411 23.8139C23.3838 23.7219 23.4174 23.6286 23.4784 23.5566C23.563 23.4571 23.7022 23.4003 23.82 23.4584C24.6686 23.8763 25.6411 24.0995 26.6808 24.0995H38.0099L38.8651 19.6555V19.6558Z" fill="#59C369" />
    </g>
    <defs>
      <clipPath id="clip0_6488_548338">
        <rect width="40" height="37.8952" fill="white" transform="translate(0 0.0522461)" />
      </clipPath>
    </defs>
  </StyledIconWMO>
)
export default CpPlusSymbolGreen
